import React, { useRef } from 'react';
import { Popup as MyPopup, ToolbarItem } from 'devextreme-react/popup';
import TextBox from 'devextreme-react/text-box';
import { apiBaseURL } from '../../Utils/ProjectConstants.js';


export default function Popup({ showPopup, setPopup, setSelectedPO, selectedPO, fetchSuccessful, mutate, fetch }){
    const issue = useRef('');

    const onValueChanged = (e) => {
        issue.current = e.value
    }

    if (showPopup === 'Put On Hold') {

        const submitRequest = async (e) => {
            console.log('submitRequest issue', issue.current);
            let request = selectedPO;
            const response = await fetch.post(`${apiBaseURL}/api/Approval/Deny/PurchaseOrder?purchaseOrderId=${request.id}&comment=${issue.current}`);
            console.log(response)
            if (fetchSuccessful(response)) {
                mutate();
                setPopup('')
            }
        }

        return (
            <MyPopup
                visible={true}
                onHiding={() => {
                    setPopup('');
                    setSelectedPO({});
                    issue.current = '';
                }}
                hideOnOutsideClick={true}
                title="Request Hold Reasoning"
                width="50%"
                height="auto"
                resizeEnabled={true}
            >
                <TextBox placeholder="Explain issue..." onValueChanged={onValueChanged} valueChangeEvent="input" />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{
                        text: "Send",
                        onClick: (e) => { submitRequest(e) }
                    }}
                />
            </MyPopup>
        );

    } else if (showPopup === 'Cancel Order') {

        const submitRequest = async (e) => {
            let request = selectedPO;
            const body = {
                orderId: request.id,
                comment: `Cancelled Reason: ${issue.current}`
            };
            await fetch.post(`${apiBaseURL}/api/PurchaseOrder/Comments`, body);
            const response = await fetch.delete(`${apiBaseURL}/api/PurchaseOrders?orderId=${request.id}&comment=${issue.current}`);
            if (fetchSuccessful(response)) {
                mutate();
                setPopup('');
            }
        }

        return (
            <MyPopup
                visible={true}
                onHiding={() => {
                    setPopup('');
                    setSelectedPO({});
                    issue.current = '';
                }}
                hideOnOutsideClick={true}
                title="Cancel Request Reasoning"
                width="50%"
                height="auto"
                resizeEnabled={true}
            >
                <TextBox
                    placeholder="Explain issue..."
                    onValueChanged={onValueChanged}
                    valueChangeEvent="input"
                />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{
                        text: "Send",
                        onClick: (e) => { submitRequest(e) }
                    }}
                />
            </MyPopup>
        );
    }
}